"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tslib = require("tslib");

var _rebass = require("rebass");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Flex = (0, _styledComponents.default)(_rebass.Flex)(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)([""], [""])));
var _default = Flex;
exports.default = _default;
var templateObject_1;